// Where a signed-in session lands when nothing asked for a specific place.
//
// A returning provider lands on the dashboard: its journey card leads a
// provider who has not finished setting up to the right next step, and a
// set-up provider is already home. Registration (a brand-new account) is not
// a login and keeps its own landing on the profile walk. Explicit
// destinations (a stored post-login redirect, a dream-schedule handoff) are
// decided by the caller before this.

export const PROVIDER_LOGIN_LANDING = '/provider/dashboard';

// A provider's session: 'CRNA' is the role the backend issues to every
// provider type; 'PROVIDER' is an older token role that Login and OAuth
// already treat as a provider.
export const isProviderLoginRole = (role) => role === 'CRNA' || role === 'PROVIDER';

// App.js sends a signed-in visitor of /, /login or /register here. Every role
// but the provider lands where it always has.
export function signedInLandingPath(role) {
  if (isProviderLoginRole(role)) return PROVIDER_LOGIN_LANDING;
  switch (role) {
    case 'ADMIN':
      return '/admin';
    case 'GROUP':
      return '/company/dashboard';
    case 'MARKETING':
      return '/marketing/overview';
    default:
      return '/provider/profile';
  }
}
